import React from 'react';
import PropTypes from 'prop-types';
import { SummaryBox } from '../style';
import commaNumber from 'comma-number';

const Summary = ({ order }) => {
  const { products, partner } = order;
  return (
    <SummaryBox>
      <div className="header">Groceries purchased</div>

      <div className="content">
        <div className="body">
          {products?.map((data) => (
            <div key={data._id} className="card">
              <img src={data.product.image} alt={partner?.business_name} />
              <div>
                <h6>
                  {data.product.name} - {data.product.weight} {data.product.unit}
                </h6>
                <h6 className="price">
                  {order?.amount_paid?.currency?.symbol}
                  {commaNumber(data?.price?.value)}
                </h6>
                <h6>Qty: {data?.quantity}</h6>
              </div>
            </div>
          ))}
        </div>

        <div className="subTotal_box">
          <p>Subtotal</p>
          <p style={{ fontWeight: 500 }}>
            {order?.amount_paid?.currency?.symbol}
            {commaNumber(order?.amount_paid?.value)}
          </p>
        </div>
        <div className="total_box">
          <p>Total</p>
          <p style={{ color: '#549A9A' }}>
            {order?.amount_paid?.currency?.symbol}
            {commaNumber(order?.amount_paid?.value)}
          </p>
        </div>
      </div>
    </SummaryBox>
  );
};

export default Summary;

Summary.propTypes = {
  order: PropTypes.object.isRequired,
};
